import { Card } from "primereact/card";
import { QueBasic } from "./QueBasic";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { Editor } from "../editor/Editor";
import { useEffect, useRef, useState } from "react";
import CmsService from "../../../service/CmsService";
import { QueCat } from "./QueCat";
import CatService from "../../../service/CatService";
import { useLocation, useNavigate, useParams,useSearchParams } from "react-router-dom";
import { Messages } from "primereact/messages";
import AttrForm from "../../cat/udf/AttrForm";
import { QueScoring } from "./QueScoring";
import { ButtonMenu } from "../../common/ButtonMenu";
import { SelectButton } from "primereact/selectbutton";
import { Tag } from "primereact/tag";
import { ConfirmDialog,confirmDialog } from "primereact/confirmdialog";
import { QueProps } from "./QueProps";
import { QueStats } from "./QueStats";
import { QueSettings } from "./QueSettings";
import { QueReviews } from "./QueReviews";
import { QueLogs } from "../LogGrid";
import { useTranslation } from "react-i18next";

export function QueEditPageUpdate({id})
{
    const {t} = useTranslation();    
    let params = useParams();
    id = params.id;
    const location = useLocation();
    const wrk = location.state; // passed by navigate
    const [progSettings,setProgSettings]=useState(null);    
    const [question,setQuestion] = useState(null);
    const messages = useRef([]);

    const retrieveProgSettings=(courseId)=>{
        CatService.getProg(courseId).then((ret)=>{
            setProgSettings(ret.catAttr);
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    }
	const showError = (err) => {
		messages.current.show({ severity: 'error', summary: t('error'), detail: t("@error."+err)});
	}	
    useEffect(()=>{
    },[]);
    useEffect(()=>{
        setQuestion(null);
        CmsService.getQuestion(id).then((ret)=>{
            console.log('question:'+JSON.stringify(ret));
            //if(ret.que.typeExt == undefined)
            //    ret.que.typeExt={};
            //else
            //    ret.que.typeExt = JSON.parse(ret.que.typeExt); //string to obj            
            setQuestion(ret);
            retrieveProgSettings(ret.que.catId);
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    },[id]);
    return (question!=null && progSettings!=null?
    <QueEditPage question={question} wrk={wrk} questionType={question.que.itemType} progSettings={progSettings}
        courseId={question.que.crsId} group={question.grp}/>:<><Messages ref={messages}></Messages></>)
}
export function QueEditPageNew({courseId,grpId,questionType})
{
    const {t} = useTranslation();
    let params = useParams();
    courseId = params.courseId;
    grpId = params.grpId;
    let [searchParams] = useSearchParams();
    questionType=searchParams.get("questionType");
    const opts=(questionType != 'MC' && questionType != 'MR')?0:4;
    const messages = useRef([]);

    const [grp,setGrp]=useState(null);
    const [progSettings,setProgSettings]=useState(null);

    const retrieveGrp=()=>{
        CmsService.getGrp(grpId).then((ret)=>{
            setGrp(ret);
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    };
	const showError = (err) => {
		messages.current.show({ severity: 'error', summary: t('error'), detail: t("@error."+err)});
	}	    
    const retrieveProgSettings=()=>{
        CatService.getProg(courseId).then((ret)=>{
            setProgSettings(ret.catAttr);
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    }
    useEffect(()=>{
        if(grpId!=undefined)
            retrieveGrp();
        retrieveProgSettings();
    },[]);

    const question={que:{itemType:questionType,parentId:grpId,catId:courseId,options:opts,difficulty:3,answer:'',weight:1.0,typeExt:null},attrs:{},objCats:[]};

    return (progSettings!=null && (grpId == undefined || grp!=null)?
        <QueEditPage question={question} group={grp} courseId={courseId} questionType={questionType} progSettings={progSettings}/>
        :
        <><Messages ref={messages}></Messages></>);
}
export function QueEditPage({question,courseId,questionType,group,wrk,progSettings})
{
    const {t} = useTranslation();
    const contentTypes=[{label:'Question',value:'BODY'},{label:'Solution',value:'SOLN'}];

    let navigate = useNavigate();    
    const opts=(questionType != 'MC' && questionType != 'MR')?0:4;
    console.log("QueEditPage:courseId:"+courseId+" que.id:"+question.que.id);
    if(group!=undefined && question.que.id == undefined)
        question.que.catId = group.catId;

    const [sessionId,setSessionId] = useState('');
    const [que,setQue]=useState(question.que);
    const [objCats,setObjCats]=useState(question.objCats?question.objCats.filter((oc)=>!oc.mainCat):[]);
    const [udfs,setUdfs]=useState([]);
    const [attrs,setAttrs]=useState(question.attrs);
    const [fields,setFields]=useState(question.typeExtra?question.typeExtra.items:[]);
    const [grp,setGrp]=useState(group);
    const [modified,setModified]=useState(true);
    const [scoreInfo,setScoreInfo]=useState(question.typeExtra?question.typeExtra.scoreInfo:null);
    const [activeTab,setActiveTab]=useState(0);
    const editor = useRef(null);
    const messages = useRef([]);

    const toolBarStart=()=>{
        var tbContent=[];
        if(que.id!=undefined)
        {
            tbContent.push(<span>ID: {que.id}</span>);
            tbContent.push(<span>{t('Date')+':'} {que.timeCreated.toLocaleString()}</span>);
            if(que.locked)
                tbContent.push(<i className="pi pi-lock"></i>);
            else
                tbContent.push(<i className="pi pi-lock-open"/>);
            if(que.approved)
                tbContent.push(<i className="pi pi-check"></i>);
        }
        if(grp!=undefined)
            tbContent.push(<span>Group: {grp.name}</span>);
        return( 
        <>
        {grp==undefined?<Button severity="secondary" label={t('New_Question')} icon="pi pi-plus" onClick={onNew}/>:''}
        <div className="ml-4"><div className="flex gap-4 flex-wrap">{tbContent}</div></div>
        </>
        )
    }
    const saveMenu=[{label:t('Save_only'),command:()=>onSave(false)},{label:t('Save_and_send_to_approval'),command:()=>onSave(true)}];
    const toolBarEnd=()=>{
        return(
            <>
                {groupNavigator()}
                <Button className="mr-2" severity="secondary" label={t('Back')} icon="pi pi-chevron-left" onClick={()=>navigate(-1)}></Button>
                <ButtonMenu items={saveMenu} label={t('Save')} icon="pi pi-save" outlined disabled={!modified}/>
            </>
        )
    }
    const confirmSave = (accept,reject) => {
        confirmDialog({
            message: t('There_are_unsaved_changes_do_you_want_to_proceed'),
            header: t('Confirmation'),
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept: accept,
            reject: reject
        });
    };    
    const checkSave=(accept)=>{
        if(modified)
        {
            confirmSave(accept,()=>{});
        }
        else
            accept();
    }
    const onNew=()=>{
        checkSave(()=>navigate(0));
    }
    const onGrpNavChange=(e)=>{

        if(e.target.value == 'Group') //group header
            navigate('/itembank/grp/'+grp.id);
        else
        {
            var qid = grp.qids[parseInt(e.target.value)-1];
            navigate('/itembank/question/'+qid);
        }
    }
    const groupNavigator=()=>{
        if(grp == undefined)
            return '';
        var items=[];
        var val;
        items.push('Group');
        grp.qids.forEach((item,index)=>{
            items.push(index+1);
            if(que.id != undefined && que.id == item)
                val=items[index+1];
        });
        if(que.id == undefined)
        {
            items.push(grp.qids.length+1);
            val=items[grp.qids.length+1];
        }      
        return(
            <SelectButton className="mr-4" value={val} onChange={onGrpNavChange} options={items} />
        );
    }
    const onFieldsChange=(flds)=>{
        setFields(flds);
    
        var ans='';//que.answer;
        flds.forEach(f => {
            if(f.itemType == 'FIB')
            {
                if(f.fibType == 'TEXT' && f.answers != undefined)
                    ans = ans + (ans.length>0?' | ':'') + f.answers[0];
                else if(f.fibType == 'LIST')
                    ans = ans + (ans.length>0?' | ':'') + f.correctOption;    
            }
            else if(f.itemType == 'MATCH')
            {
                var matchAns="";
                f.answers.forEach(element => {
                    matchAns=matchAns+element;
                });
                ans = ans + (ans.length>0?' | ':'') + matchAns;
            }
        });
        var qu={...que};
        qu.answer=ans;
        //qu.typeExt.fields=flds;
        setQue(qu);
        setModified(true);
        return ans;
    };
    const onSave=(sendToApproval)=>{
        if(!checkValues())
            return;
        var catIds = objCats.map((oc)=>oc.id);
        editor.current.save(que.id).then((saveInfos)=>{
            var datsSaved=[];
            var sessions=[];
            var fields=[];
            var mediaLinks=[];
            saveInfos.forEach((si,index)=>{
                datsSaved=datsSaved.concat(si.dats);
                sessions.push(si.sessionId);
                if(index == 0) //body
                    fields=editor.current._checkFields(si.fields);
                mediaLinks=mediaLinks.concat(si.mediaLinks);
            });

            //if(editor.current.checkFields().then((fields)=>{
                var answer = onFieldsChange(fields);
                var createDto={que:{...que},cats:catIds,dats:[],attrs:attrs,wrkId:wrk!=undefined?wrk.id:null,sendToApproval:sendToApproval};
                //createDto.dats=saveInfo.dats;
                if(questionType=='FIB'||questionType=='MATCH')
                    createDto.que.answer = answer;
                createDto.sessions=sessions;   
                createDto.typeExtra={items:fields};
                if(scoreInfo)
                    createDto.typeExtra.scoreInfo=scoreInfo;
                createDto.que.typeExt=null;
                //createDto.que.typeExt.fields=fields;
                //createDto.que.typeExt = JSON.stringify(createDto.que.typeExt);
                createDto.mediaLinks = mediaLinks;
                //createDto.fields=fields;
                if(que.id == undefined)
                {
                    CmsService.createQuestion(createDto).then((ret)=>{
                        console.log("saved:"+JSON.stringify(ret));
                        if(grp != undefined)
                        {
                            var group = {...grp};
                            group.qids.push(ret.id);
                            setGrp(group);
                        }
                        setQue(ret); 
                        setModified(false);
                    }).catch((error)=>{
                        showError(error.response.data?error.response.data.message:error.message);
                    });
                }
                else
                {
                    CmsService.updateQuestion(que.id,createDto).then((ret)=>{
                        console.log("saved:"+JSON.stringify(ret));
                        //if(ret.typeExt == undefined)
                        //    ret.typeExt={};
                        //else
                        //    ret.typeExt = JSON.parse(ret.typeExt); //string to obj                        
                        setQue(ret); 
                        setModified(false);
                    }).catch((error)=>{
                        showError(error.response.data?error.response.data.message:error.message);
                    });
                }
            //}));
        })
    };
	const showError = (err) => {
		messages.current.show({ severity: 'error', summary: t('error'), detail: t("@error."+err)});
	}	
    const checkValues=()=>{
        if(que.answer == undefined || que.answer.trim().length == 0)
        {
            if(que.itemType == 'MC' || que.itemType == 'MR')
            {
                showError('Answer_not_selected');
                return false;    
            }
        }
        return true;
    };
    const onScoreInfo=(scoreInfo)=>{
        //var qu={...que};
        //qu.typeExt={scoring:scoreInfo};
        //setQue(qu);
        setScoreInfo(scoreInfo);
        setModified(true);
    }
    const onBasicChange=(q)=>{
        var qu={...que,...q};
        setQue(qu);
        setModified(true);
    };
    const onSettingsChange=(q)=>{
        var qu={...que,...q};
        setQue(qu);
        setModified(true);
    };
    const onAttrsChange=(attrs)=>{
        setAttrs(attrs);
        setModified(true);
    }
    const onDocumentModified=()=>{
        if(!modified)
            setModified(true);
    }
    const setCats=(cats)=>{
        setObjCats(cats);
        setModified(true);
    };
    useEffect(()=>{
        console.log("QueEditPage:courseId:"+courseId);
        retrieveUdfs();
    },[]);
    const retrieveUdfs=()=>{
        CatService.getUdfByEntity('Question').then((ret)=>{
            setUdfs(ret);
        }).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
    };
    const onTabChange=(index)=>{
        console.log("TAB:"+index);
        setActiveTab(index);
    }

    return(
        <div className="grid gap-2">
        <Card className="col-12 xl:col-8">
         <Toolbar start={toolBarStart} end={toolBarEnd}/>
         <Messages ref={messages}></Messages>   
         <ConfirmDialog/>      
         <TabView className="mt-2" renderActiveOnly={false} onTabChange={(e)=>onTabChange(e.index)} activeIndex={activeTab}>
            <TabPanel header={t('Question')}>                
                <QueBasic question={que} questionType={questionType} courseId={courseId} onChange={onBasicChange}></QueBasic>
                <Editor ref={editor} dats={question.dats} fields={fields} defFont={progSettings.itemBankFontFace} defFontSize={progSettings.itemBankFontSize}
                    options={que.options} ctypes={contentTypes} mode="question"
                    onFieldsChange={onFieldsChange} onModified={onDocumentModified} t={t} showError={showError}></Editor>
            </TabPanel>
            <TabPanel header={t('Settings')}>                
                <QueSettings question={que} questionType={questionType} courseId={courseId} onChange={onSettingsChange}></QueSettings>
            </TabPanel>
            <TabPanel header={t('Outcomes')}>
                <QueCat objCats={objCats} question={que} courseId={courseId} onChange={setCats}></QueCat>
            </TabPanel>
            <TabPanel header={t('Scoring')} visible={que.itemType=='OE'}>
                <QueScoring onChange={onScoreInfo} scoreInfo={scoreInfo}/>
            </TabPanel>
            <TabPanel header={t('Properties')} visible={que.id !=undefined}>
                <QueProps question={que}/>
            </TabPanel>
            <TabPanel header={t('Attribs')}>
                <AttrForm udfs={udfs} attrs={attrs} onChange={onAttrsChange}></AttrForm>
            </TabPanel>
            <TabPanel header={t('Statistics')} visible={que.id !=undefined}>
                <QueStats question={que}/>
            </TabPanel>
            <TabPanel header={t('Reviews')} visible={que.id !=undefined}>
                <QueReviews id={activeTab==7?que.id:0}/>
            </TabPanel>
            <TabPanel header={t('Logs')} visible={que.id !=undefined}>
                <QueLogs id={activeTab==8?que.id:0}/>
            </TabPanel>
         </TabView>
        </Card>
        </div>
    )
}